import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';

const ownerReLetHeading = {
    colId: 'ownerReLet',
    headerName: 'Owner Re-Let',
    field: 'ownerReLet',
    editable: true,
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        values: ['', 'Y', 'N'],
    },
    supressKeyboardEvent: allowUpAndDownOnEdit(),
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
    },
    width: 120,
    hide: true,
};

export default ownerReLetHeading;
